import TransportStream from 'winston-transport';

interface IConsoleLogMessage { message: string; [key: string]: any; }

export default class RollbarTransport extends TransportStream {
	public log(data: IConsoleLogMessage, next: () => any) {
		setImmediate(() => {
			this.emit('logged', data);
		});
		const rollbar = (window as any).Rollbar;
		if (rollbar && rollbar[data.level]) {
			rollbar[data.level](data.message, data);
		}
		next();
	}
}
